export default __webpack_public_path__ + "static/media/pop_cat.017f08f3.mp3";